export enum STEP_NAME {
  INTRO = 'INTRO',
  PATIENT = 'PATIENT',
  MEDICATIONS = 'MEDICATIONS',
  PLACEHOLDER = 'DOCTOR/PHARMACY',
  PHARMACY = 'PHARMACY',
  DOCTOR = 'DOCTOR',
  ADDITIONAL_INFO = 'ADDITIONAL INFO',
  CONFIRMATION = 'CONFIRMATION',
}
